import React, {useEffect} from 'react';
import {getCookie} from '../../../../utils/getCookie';
import * as S from './RefundRaiseRequestListing.styles';

const RefundRaiseRequestListing = listingData => {
  const ccdeCookie = getCookie('ccde');

  return (
    <S.SRListing>
      <table width="100%">
        <thead>
          <tr>
            <th>Transaction Date</th>
            <th>Request ID</th>
            <th>{ccdeCookie === 'AE' ? 'Reference Number' : 'UTR'}</th>
            <th>Amount</th>
            <th>Payment Mode</th>
            <th>Status</th>
            <th>Status Notes</th>
          </tr>
        </thead>
        {listingData?.listingData?.length && (
          <tbody>
            {listingData?.listingData.map(
              ({
                id,
                transaction_date_time,
                request_id,
                utr,
                transaction_amount,
                payment_mode,
                status,
                status_notes,
              }) => {
                return (
                  <tr key={id}>
                    {transaction_date_time && (
                      <td>
                        {transaction_date_time && (
                          <S.ListText>{transaction_date_time.substring(0, 10)}</S.ListText>
                        )}
                        {/*transactionTime && <S.ListSmallText>{transactionTime}</S.ListSmallText>*/}
                      </td>
                    )}
                    {request_id && (
                      <td>
                        <S.ListText>{request_id}</S.ListText>
                      </td>
                    )}
                    {utr && (
                      <td>
                        <S.ListText>{utr}</S.ListText>
                      </td>
                    )}
                    {transaction_amount && (
                      <td>
                        <S.ListText>{transaction_amount}</S.ListText>
                      </td>
                    )}
                    {payment_mode && (
                      <td>
                        <S.ListText>{payment_mode}</S.ListText>
                      </td>
                    )}
                    {status && (
                      <td>
                        <S.ListStatusText>{status}</S.ListStatusText>
                      </td>
                    )}
                    {status_notes && (
                      <td>
                        <S.ListText>{status_notes}</S.ListText>
                      </td>
                    )}
                  </tr>
                );
              },
            )}
          </tbody>
        )}
      </table>
    </S.SRListing>
  );
};

export default RefundRaiseRequestListing;
